import {
  DELETE_USER,
  DELETE_USER_FAILED,
  DELETE_USER_SUCCESS,
  EDIT_USER,
  EDIT_USER_FAILED,
  EDIT_USER_SUCCESS,
  FETCH_ALL_USERS,
  FETCH_ALL_USERS_FAILED,
  FETCH_ALL_USERS_SUCCESS,
} from "../store/types";
import {
  cloud_function_server_url
} from '../../config';

const END_POINT = `${cloud_function_server_url}/user`;
const AUTH_END_POINT = `${cloud_function_server_url}/auth`;

export const fetchUsers = () => (dispatch) => (firebase) => {

  // const {
  //   usersRef
  // } = firebase;

  dispatch({
    type: FETCH_ALL_USERS,
    payload: null
  });

  fetch(`${END_POINT}/get-all-users`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(async (res) => {
      const response = await res.json();
      const data = response?.data?.map((item) => {
        return { ...item, id: item.uid }
      });
      dispatch({
        type: FETCH_ALL_USERS_SUCCESS,
        payload: data
      });
    }).catch(error => {
      console.log("res check error", error)
      dispatch({
        type: FETCH_ALL_USERS_FAILED,
        payload: "No users available."
      });
    });

  // usersRef.on("value", snapshot => {
  //   if (snapshot.val()) {
  //     const data = snapshot.val();
  //     const arr = Object.keys(data)
  //       .filter(i => data[i].usertype != 'admin')
  //       .map(i => {
  //         data[i].id = i;
  //         return data[i];
  //       });
  //     dispatch({
  //       type: FETCH_ALL_USERS_SUCCESS,
  //       payload: arr
  //     });
  //   } else {
  //     dispatch({
  //       type: FETCH_ALL_USERS_FAILED,
  //       payload: "No users available."
  //     });
  //   }
  // });
};

export const deleteUser = (uid) => (dispatch) => (firebase) => {
  // const {
  //   singleUserRef,
  //   vehiclesRef,
  //   singleVehicleRef,
  //   auth
  // } = firebase;


  fetch(`${END_POINT}/delete-user/${uid}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(async (res) => {
      const response = await res.json();
      console.log("response", response)
      fetchUsers()(dispatch)(firebase)
    }).catch(error => {
      console.log("res check error", error)
    });

  // singleUserRef(uid).remove().then(() => {
  //   vehiclesRef.on("value", snapshot => {
  //     if (snapshot.val()) {
  //       const data = snapshot.val();
  //       const arr = Object.keys(data)
  //         .map(i => {
  //           data[i].id = i;
  //           return data[i];
  //         });

  //       arr.map(item => {
  //         if (item.driver === uid) {
  //           let vehicleObject = {
  //             driver: ""
  //           }
  //           singleVehicleRef(item.id).update(vehicleObject);
  //         }
  //       });
  //     }
  //   });
  //   if (auth.currentUser.uid == uid) {
  //     auth.signOut();
  //     dispatch({
  //       type: USER_DELETED,
  //       payload: null
  //     });
  //   }
  // });
};

export const fetchDrivers = () => (dispatch) => (firebase) => {

  const {
    usersRef
  } = firebase;

  dispatch({
    type: FETCH_ALL_USERS,
    payload: null
  });

  fetch(`${END_POINT}/fetch-drivers`, {
    method: 'GET',
  })
    .then(async (res) => {
      const response = await res.json();
      console.log("fetchDrivers", response)
      if(response?.success) {
        const arr = response.data?.map((item) => {
          item.id = item._id;
          return item;
        });
        dispatch({
          type: FETCH_ALL_USERS_SUCCESS,
          payload: arr
        });
      } else {
        dispatch({
          type: FETCH_ALL_USERS_FAILED,
          payload: "No users available."
        });
      }
    }).catch(error => {
      console.log("fetchDrivers error", error)
      dispatch({
        type: FETCH_ALL_USERS_FAILED,
        payload: "No users available."
      });
    });

  // usersRef.orderByChild("queue").equalTo(false).once("value", snapshot => {
  //   if (snapshot.val()) {
  //     const data = snapshot.val();
  //     const arr = Object.keys(data)
  //       .filter(i => data[i].approved == true && data[i].driverActiveStatus == true && data[i].location)
  //       .map(i => {
  //         data[i].id = i;
  //         return data[i];
  //       });
  //     dispatch({
  //       type: FETCH_ALL_USERS_SUCCESS,
  //       payload: arr
  //     });
  //   } else {
  //     dispatch({
  //       type: FETCH_ALL_USERS_FAILED,
  //       payload: "No users available."
  //     });
  //   }
  // });
};

export const addUser = (userdata) => (dispatch) => (firebase) => {
  // const {
  //   usersRef
  // } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: userdata
  });

  fetch(`${AUTH_END_POINT}/user-signup`, {
    method: 'POST',
    body: userdata,
    // headers: {
    //   'Content-Type': 'application/json',
    // },
  })
    .then(async (res) => {
      const response = await res.json();
      console.log("response", response)
      dispatch({
        type: EDIT_USER_SUCCESS,
        payload: null
      });
      fetchUsers()(dispatch)(firebase)
    }).catch(error => {
      console.log("res check error", error)
      dispatch({
        type: EDIT_USER_FAILED,
        payload: error
      });
    });

  // usersRef.orderByChild("queue").equalTo(false).once("value", snapshot => {
  //   if (snapshot.val() && snapshot.exists()) {
  //     const data = snapshot.val();
  //     const arr = Object.keys(data)
  //       .filter(i => data[i].usertype == "driver");

  //     if (userdata.usertype === 'driver') {
  //       userdata.roll_no = "ZBT-" + arr.length;
  //     }

  //     usersRef.push(userdata).then(() => {
  //       dispatch({
  //         type: EDIT_USER_SUCCESS,
  //         payload: null
  //       });
  //     }).catch((error) => {
  //       dispatch({
  //         type: EDIT_USER_FAILED,
  //         payload: error
  //       });
  //     });
  //   } else if (!snapshot.exists()) {
  //     if (userdata.usertype === 'driver') {
  //       userdata.roll_no = "ZBT-1";
  //     }

  //     usersRef.push(userdata).then(() => {
  //       dispatch({
  //         type: EDIT_USER_SUCCESS,
  //         payload: null
  //       });
  //     }).catch((error) => {
  //       dispatch({
  //         type: EDIT_USER_FAILED,
  //         payload: error
  //       });
  //     });
  //   } else {
  //     dispatch({
  //       type: EDIT_USER_FAILED,
  //       payload: "No users available."
  //     });
  //   }
  // });
}

export const editUser = (id, user) => (dispatch) => (firebase) => {

  console.log("user check", user)

  // const {
  //   singleUserRef
  // } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: user
  });
  // let editedUser = user;
  // delete editedUser.id;

  fetch(`${END_POINT}/edit-user/${id}`, {
    method: 'PUT',
    body: user
  })
    .then(async (res) => {
      const response = await res.json();
      console.log("response", response)
      dispatch({
        type: EDIT_USER_SUCCESS,
        payload: null
      });
      fetchUsers()(dispatch)(firebase)
    }).catch(error => {
      console.log("res check error", error)
      dispatch({
        type: EDIT_USER_FAILED,
        payload: error
      });
    });


  // singleUserRef(id).set(editedUser).then(() => {

  //   dispatch({
  //     type: EDIT_USER_SUCCESS,
  //     payload: null
  //   });
  // }).catch((error) => {
  //   dispatch({
  //     type: EDIT_USER_FAILED,
  //     payload: error
  //   });
  // });
}

// export const deleteUser = (id) => (dispatch) => (firebase) => {

//   const {
//     singleUserRef
//   } = firebase;

//   dispatch({
//     type: DELETE_USER,
//     payload: id
//   });

//   singleUserRef(id).remove().then(() => {
//     dispatch({
//       type: DELETE_USER_SUCCESS,
//       payload: null
//     });
//   }).catch((error) => {
//     dispatch({
//       type: DELETE_USER_FAILED,
//       payload: error
//     });
//   });
// }

export const uploadImage = (userObj) => (dispatch) => async (firebase) => {
  const {
    driverDocsRef,
    usersRef
  } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: userObj.profile
  });

  if (userObj.userdata.profileImage) {
    let timestamp1 = new Date().getTime() + 'profileImage';
    await driverDocsRef(userObj.id, timestamp1).put(userObj.userdata.profileImage);
    userObj.userdata.profileImage = await driverDocsRef(userObj.id, timestamp1).getDownloadURL();
  }
  if (userObj.userdata.licenseFrontImage) {
    let timestamp2 = new Date().getTime() + 'licenseFrontImage';
    await driverDocsRef(userObj.id, timestamp2).put(userObj.userdata.licenseFrontImage);
    userObj.userdata.licenseFrontImage = await driverDocsRef(userObj.id, timestamp2).getDownloadURL();
  }
  if (userObj.userdata.licenseBackImage) {
    let timestamp3 = new Date().getTime() + 'licenseBackImage';
    await driverDocsRef(userObj.id, timestamp3).put(userObj.userdata.licenseBackImage);
    userObj.userdata.licenseBackImage = await driverDocsRef(userObj.id, timestamp3).getDownloadURL();
  }
  if (userObj.userdata.liveImage) {
    let timestamp4 = new Date().getTime() + 'liveImage';
    await driverDocsRef(userObj.id, timestamp4).put(userObj.userdata.liveImage);
    userObj.userdata.liveImage = await driverDocsRef(userObj.id, timestamp4).getDownloadURL();
  }
  if (userObj.userdata.aadharFrontImage) {
    let timestamp5 = new Date().getTime() + 'aadharFrontImage';
    await driverDocsRef(userObj.id, timestamp5).put(userObj.userdata.aadharFrontImage);
    userObj.userdata.aadharFrontImage = await driverDocsRef(userObj.id, timestamp5).getDownloadURL();
  }
  if (userObj.userdata.aadharBackImage) {
    let timestamp6 = new Date().getTime() + 'aadharBackImage';
    await driverDocsRef(userObj.id, timestamp6).put(userObj.userdata.aadharBackImage);
    userObj.userdata.aadharBackImage = await driverDocsRef(userObj.id, timestamp6).getDownloadURL();
  }

  let object = {
    ...userObj.userdata, ...userObj.profile
  }

  usersRef.child(userObj.id).set(object).then(() => {
    dispatch({
      type: EDIT_USER_SUCCESS,
      payload: null
    });
  }).catch((error) => {
    dispatch({
      type: EDIT_USER_FAILED,
      payload: error
    });
  });

}